'use client';

import { FaGithub, FaGoogle } from 'react-icons/fa6';
import { Button } from './ui/button';
import { cn } from '@/lib/utils';
import { signInWithOAuth } from '@/utils/server-actions/login';
import { useState, useEffect, useActionState } from 'react';
import posthog from 'posthog-js';

type ButtonProps = React.ComponentProps<typeof Button>;

const providers = {
  github: {
    provider: 'github',
    name: 'GitHub',
    icon: FaGithub,
  },
  google: {
    provider: 'google',
    name: 'Google',
    icon: FaGoogle,
  },
};

interface LoginWithOAuthProps extends ButtonProps {
  provider: keyof typeof providers;
}

const LoginWithOAuth = (props: LoginWithOAuthProps) => {
  const [, formAction, isPending] = useActionState(signInWithOAuth, null);

  const [redirectUrl, setRedirectUrl] = useState('');

  const provider = providers[props.provider];

  useEffect(() => {
    setRedirectUrl(`${window.location.origin}/auth/callback`);
  }, []);

  return (
    <form action={formAction}>
      <Button
        className="inline-flex items-center justify-center space-x-2"
        type="submit"
        disabled={isPending || !redirectUrl}
        onClick={() => posthog.capture('user_signed_in')}
      >
        <provider.icon
          size={16}
          className={cn({ 'animate-spin': isPending })}
        />
        <span>{`Sign in with ${provider.name}`}</span>
      </Button>
      <input type="hidden" name="provider" value={provider.provider} />
      <input type="hidden" name="redirect" value={redirectUrl} />
    </form>
  );
};

export default LoginWithOAuth;
